import React from 'react';
import { withProps } from 'recompose';
import { Crumb } from 'components/atoms';
import { BreadCrumbs } from 'components/molecules';

function joinUrl(base, path) {
	if (!base) return path || '';
	if (!path) return base;
	return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

export const enhance = withProps(({ facility, baseUrl, crumbs = [] }) => ({
	location: facility?.seoLocation,
	cityUrl: facility?.cityUrl,
	stateUrl: facility?.stateUrl,
	baseUrl,
	crumbs: facility?.name
		? [
				<Crumb
					key="facility"
					label={facility.name}
					to={joinUrl(baseUrl, facility.url)}
					isLast={!crumbs.length}
				/>,
				...crumbs,
			]
		: crumbs,
}));

export default enhance(BreadCrumbs);
